module.exports = __webpack_public_path__ + "static/media/accept.8ac9521f.svg";